import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import ManualConfiguration from "../../../../components/Partners/DataIntegrations/Brands/ManualBrandConfiguration/ManualConfiguration";
import ComingSoon from "../../../../components/ComingSoon/ComingSoon";

const ManualBrandConfigurationScreen = () => {
  let react_env = import.meta.env.VITE_ENV; // env-check: intentional
  const userData = useSelector(selectUserData);
  const hasManualConfiguration = CheckPermissions(
    userData?.data?.products?.data_collection,
    "brands",
    "view_brands",
  );

  return (
    <>
      {hasManualConfiguration &&
      (react_env === "staging" || react_env === "development") ? ( // env-check: intentional
        <ManualConfiguration />
      ) : (
        <ComingSoon />
      )}
    </>
  );
};

export default ManualBrandConfigurationScreen;
